import React from "react";
import { useSearchParams } from "react-router-dom";
import FormTabs from "@/components/FormTabs";
import { useAuth } from "@/context/AuthContext";
import { PAGE_ACCESS } from "@/lib/pageAccess";
import PersonnelCategories from "@/pages/mdm/PersonnelCategories";
import EducationLevels from "@/pages/mdm/EducationLevels";
import Functions from "@/pages/mdm/Functions";
import CustomFieldDefs from "@/pages/core/CustomFieldDefs";

// Nomenclatoarele organizației, grupate într-o singură pagină cu file. Fiecare filă e pagina de dinainte (aceleași drepturi: `PAGE_ACCESS` al rutei
// ei vechi) și se vede doar cui are dreptul respectiv.
export const NOMENCLATOARE_TABS = [
  { id: "categorii", label: "Categorii de personal", page: "/mdm/personnel-categories", Comp: PersonnelCategories },
  { id: "studii", label: "Niveluri de studii", page: "/mdm/education-levels", Comp: EducationLevels },
  { id: "functii", label: "Funcții și coduri COR", page: "/mdm/functions", Comp: Functions },
  { id: "campuri", label: "Câmpuri personalizate", page: "/admin/custom-fields", Comp: CustomFieldDefs },
];

export default function Nomenclatoare() {
  const { allowed } = useAuth();
  const [params, setParams] = useSearchParams();
  const visible = NOMENCLATOARE_TABS.filter(t => allowed(PAGE_ACCESS[t.page].roles, PAGE_ACCESS[t.page].perm));
  const current = visible.find(t => t.id === params.get("tab")) || visible[0];
  if (!current) return <div className="card" style={{ padding: 20 }}>Nu ai acces la niciun nomenclator.</div>;
  const Comp = current.Comp;
  return (
    <>
      <FormTabs tabs={visible} value={current.id} onChange={id => setParams({ tab: id }, { replace: true })} />
      <div style={{ marginTop: 14 }}><Comp key={current.id} /></div>
    </>
  );
}
